module.exports = __webpack_public_path__ + "static/media/laura.7e75d975.png";